import { Box, Typography } from '@material-ui/core';

import { ReactComponent as VerifiedIcon } from 'assets/images/selo-verificado.svg';

interface OfficialWhatsAppIndicatorProps {
  size?: 'small' | 'normal';
}

export default function OfficialWhatsAppIndicator({
  size = 'normal',
}: OfficialWhatsAppIndicatorProps) {
  const smallSize = size === 'small';
  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <VerifiedIcon style={{ width: smallSize ? 11 : 12 }} />
      <Typography
        variant="caption"
        style={{
          color: '#0daa29',
          fontWeight: 500,
          fontSize: size === 'small' ? 11 : 12,
        }}
      >
        <b>WhatsApp</b> Oficial
      </Typography>
    </Box>
  );
}
